import React from 'react'
import { Link } from 'react-router-dom'
import EventsScript2025 from "../../component/IITTP/Events/EventsArray2025";
import EventsScript2024 from "../../component/IITTP/Events/EventsArray2024";
// import EventsScript2023 from "../../component/IITTP/Events/EventsArray2023";
function Event() {

    
    const combinedEvents =[...EventsScript2025, ...EventsScript2024]
    

    const LatestEvents = combinedEvents.slice(0, 4);

//     const events = [
//     {
//         venue: 'IIT Tirupati',
//         title: 'Body Politics: The Philosophy of Autobiography Through Literature',
//         description: 'This GIAN course offers intimate readings of a diverse range of global autobiographical literature...',
//         link: '/',
//         img: 'assets/img/events/body_politics.png',
//         dt: '18',
//         my: 'July 2023',
//         duration: '5 days',
//     },
//     {
//         venue: 'IIT Tirupati',
//         title: 'Pre-incubation contest "Technical Business Ideas 2023"',
//         description: `The Pre-incubation cell at IIT
//         Tirupati invites the
//         application from students,
//         stating their innovative...`,
//         link: '/',
//         img: 'assets/img/events/technical_business_ideas.png',
//         dt: '26',
//         my: 'July 2023',
//         duration: '',
//     },{
//         venue: 'IIT Tirupati',
//         title: 'Indo-German Workshop on Data Mathematics and Scientific Computing',
//         description: `Data mathematics plays a critical role in many
//         areas of modern science, engineering, and
//         technology...`,
//         link: '/',
//         img: 'assets/img/events/indo_german_workshop.png',
//         dt: '8',
//         my: 'September 2023',
//         duration: '5 days',
//     },{
//         venue: 'IIT Tirupati',
//         title: 'Processing and Fabrication of Advanced Materials (29th PFAM 2023)',
//         description: `We welcome you to the Twenty-Ninth International Conference 
//         on Processing and Fabrication of...`,
//         link: '/',
//         img: 'assets/img/events/pfam2023.png',
//         dt: '6',
//         my: 'July 2023',
//         duration: '3 days',
//     },{
//         venue: 'IIT Madras',
//         title: '30th National Conference on Communications (NCC 2024)',
//         description: 'The National Conference on Communications (NCC) is the flagship conference of India...',
//         link: '/',
//         img: 'assets/img/events/ncc2024.png',
//         dt: '28',
//         my: 'Feb 2024',
//         duration: '4 days',
//     },{
//         venue: 'IIT Tirupati',
//         title: 'Five-Day Workshop on "Finite Element Methods- Theory and Practice (Ansys)"',
//         description: 'This course is designed to the faculty involved in teaching the course on finite element method...',
//         link: '/',
//         img: 'assets/img/events/ansys.png',
//         dt: '19',
//         my: 'June 2023',
//         duration: '5 days',
//     },
    
// ];

  return (
    <>
        <section className="event home-events-section pt-80 pb-90 p-relative fix">
           
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 p-relative">
                        <div className="section-title center-align mb-50 wow fadeInDown animated"
                            data-animation="fadeInDown"
                            data-delay=".4s">
                            {/* <h5>
                                <i className="fal fa-graduation-cap" /> Our Events
                            </h5> */}
                            <h2 className='titleh3'>Events</h2>
                        </div>
                        
                    </div>
                </div>
                <div className="row">
                {LatestEvents.map((event, index) => (

                    <div key={index} className="col-lg-3 col-md-6 col-12 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                        <article className="home-event-card mb-30">
                            <div className="home-event-thumb">
                                <Link to={event.link}>
                                <img className='lazyLoad' src={event.img} alt={event.title} />
                                </Link>
                            </div>
                            <div className="home-event-content">
                                <div className="home-event-date">
                                <strong>{event.dt}</strong> {event.my}
                                </div>
                                <h3>
                                <Link to={event.link}>
                                    {event.title}
                                </Link>
                                </h3>
                                <p className="home-event-description">
                                {event.description}
                                </p>
                                <div className="home-event-meta">
                                    {event.duration && <span><i className="fal fa-clock" /> {event.duration}</span>}
                                    <span><i className="fal fa-map-marker-alt" /> {event.venue}</span>
                                </div>
                            </div>
                        </article>
                    </div>
                
                ))}
                
                </div>
                <div className="slider-btn float-end">
                    <Link to="/home-events-list" className="btn ss-btn smoth-scroll">
                        View All <i className="fal fa-long-arrow-right" />
                    </Link>
                </div>
            </div>
        </section>
    </>
  )
}

export default Event